import React, { useEffect, useRef } from "react";

export const Modal = ({
  isOpen,
  toggle,
  centered,
  size,
  style,
  className,
  children,
}) => {
  const backdropRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
    return () => document.body.classList.remove("modal-open");
  }, [isOpen]);

  if (!isOpen) return null;

  const sizeClass = size === "lg" ? "modal-lg" : size === "sm" ? "modal-sm" : size === "xl" ? "modal-xl" : size === "md" ? "" : "";
  const dialogClass = ["modal-dialog", sizeClass, centered ? "modal-dialog-centered" : ""].filter(Boolean).join(" ");

  return (
    <>
      <div
        className="modal fade show"
        style={{ display: "block" }}
        onClick={(e) => { if (e.target === e.currentTarget && toggle) toggle(); }}
        role="dialog"
        tabIndex="-1"
      >
        <div className={dialogClass} style={style} role="document">
          <div className={"modal-content " + (className || "")}>
            {children}
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
};

export const ModalHeader = ({ toggle, style, className, children }) => (
  <div className={"modal-header " + (className || "")} style={style}>
    {children ? <h5 className="modal-title">{children}</h5> : <span className="modal-title" aria-hidden="true" />}
    {toggle && (
      <button
        type="button"
        className="close"
        onClick={toggle}
        onMouseDown={(e) => e.preventDefault()}
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    )}
  </div>
);

export const ModalBody = ({ style, className, children }) => (
  <div className={"modal-body " + (className || "")} style={style}>
    {children}
  </div>
);

export const ModalFooter = ({ style, className, children }) => (
  <div className={"modal-footer " + (className || "")} style={style}>
    {children}
  </div>
);
